import React, { useState, useEffect } from 'react'

import './index.css'

import { Map, Marker, GoogleApiWrapper } from 'google-maps-react'
import { RiMapPin2Line } from 'react-icons/ri'

const containerStyle = {
    border: 'solid 1px rgba(0,0,0,.125)',
    width: '79%',
    marginBottom: '3rem',
    zIndex: 1,
    position: 'absolute'
}

export function MapContainer({ places, lat, lng, zoom, selectedTablePlace }) {
    const [selectedPlace, setSelectedPlace] = useState({});

    useEffect(() => {
        if (selectedTablePlace.name)
            setSelectedPlace(selectedTablePlace)
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <div>
            <div className="Map">
                <div className={(selectedPlace.name ? 'container-header' : 'display-hidden')}>
                    <div className="center place-box">
                        <h1>
                            <RiMapPin2Line style={{ marginRight: '.5rem', color:'#35A0E6', marginBottom: '5px' }} />
                            {selectedPlace.name}
                        </h1>
                        <p>
                            {selectedPlace.address}
                        </p>
                    </div>
                </div>
                <Map google={window.google}
                    onClick={() => onMapClicked()}
                    containerStyle={containerStyle}
                    initialCenter={{
                        lat: lat,
                        lng: lng
                    }}
                    zoom={zoom}>
                    {places.map((place) =>
                        renderMarker(place)
                    )}
                </Map>
            </div>
        </div>
    )

    function onMapClicked() {
    };

    function onMackerClick(place, marker) {
        setSelectedPlace(place);
    }

    function renderMarker(place) {
        return (
            <Marker
                key={place.id}
                onClick={(marker) => onMackerClick(place, marker)}
                position={{
                    lat: place.latitude,
                    lng: place.longitude
                }}
                title={place.name}
                name={place.name}
            />
        )
    }
};

export default GoogleApiWrapper({
    apiKey: ('AIzaSyA7jxVcPU88Q6MZAv7ld92abFZHBVoksk4')
})(MapContainer)

